import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TextField,
  TableRow,
  TableBody,
  Paper,
  Grid,
  CircularProgress,
  Tab,
  Chip,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import axios from "axios";
import { getSource } from "../network_requests";
import { useSelector } from "react-redux";
import reuter from "../../../assets/Reuters_logo.png";
import yahoo from "../../../assets/Yahoo_logo.png";
import tradingview from "../../../assets/Tradingview_logo.jpg";
import business from "../../../assets/Business_insider_logo.png";

const LinkButton = (props) => {
  const { value, link } = props;
  return (
    <>
      {value ? (
        <a href={link} target="_blank" style={{ textDecoration: "none" }}>
          <img
            src={
              value === "Reuter"
                ? reuter
                : value === "Yahoo"
                ? yahoo
                : value === "Trading_View"
                ? tradingview
                : value === "Bussiness_Insider"
                ? business
                : null
            }
            height={value === "Trading_View" ? "20px" : "50px"}
          />
        </a>
      ) : null}
    </>
  );
};

export default function Sources(props) {
  const { ISIN } = props;
  const [rows, setRows] = useState({
    Profile: [],
    Financials: [],
    Sustainabily: [],
    Analist: [],
    Managment: [],
    News: [],
    Key_Development: [],
    Events: [],
    Listing: [],
    Conversations: [],
    Holders: [],
    Options: [],
    Techniqual_Ananlysis: [],
    Ideas: [],
  });
  const [load, setLoad] = useState(false);
  const [name, setName] = useState("");
  const [search, setSearch] = useState(null);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);

  useEffect(async () => {
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    (async () => {
      if (ISIN) {
        setLoad(true);
        const searchData = await getSource(ISIN);
        setRows(searchData ? searchData : rows);

        setLoad(false);
      }
    })();

    return () => {
      source.cancel();
    };
  }, [ISIN]);

  return (
    <div
      style={{
        maxWidth: isDesktopOrLaptop ? "" : "300%",
      }}
    >
      <TableContainer component={Paper} style={{ minHeight: "60vh" }}>
        <Table size="small" stickyHeader>
          <TableBody>
            {load ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Grid container justifyContent="center">
                <Table style={{ width: "80vw" }}>
                  <TableHead>
                    <TableCell
                      style={{
                        fontFamily: "Overpass",

                        color: "#808080",
                        fontSize: "15px",
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      style={{
                        fontFamily: "Overpass",

                        color: "#808080",
                        fontSize: "15px",
                      }}
                    >
                      Reuters
                    </TableCell>
                    <TableCell
                      style={{
                        fontFamily: "Overpass",

                        color: "#808080",
                        fontSize: "15px",
                      }}
                    >
                      Yahoo
                    </TableCell>
                    <TableCell
                      style={{
                        fontFamily: "Overpass",

                        color: "#808080",
                        fontSize: "15px",
                      }}
                    >
                      TradingView
                    </TableCell>
                    <TableCell
                      style={{
                        fontFamily: "Overpass",

                        color: "#808080",
                        fontSize: "15px",
                      }}
                    >
                      Business Insiders
                    </TableCell>
                  </TableHead>

                  <TableBody style={{ marginTop: "20px" }}>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Company Profile
                      </TableCell>
                      {rows.Profile?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                          {/* <a href={row.url} target="_blank">
                            {row.title}
                          </a> */}
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Financials
                      </TableCell>
                      {rows.Financials.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Sustainabily
                      </TableCell>
                      {rows.Sustainabily?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Analist
                      </TableCell>
                      {rows.Analist?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Managment
                      </TableCell>
                      {rows.Managment?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>

                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        News
                      </TableCell>
                      {rows.News?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Key_Development
                      </TableCell>
                      {rows.Key_Development?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Events
                      </TableCell>
                      {rows.Events?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Listing
                      </TableCell>
                      {rows.Listing?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Conversations
                      </TableCell>
                      {rows.Conversations?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>

                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Holders
                      </TableCell>
                      {rows.Holders?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Options
                      </TableCell>
                      {rows.Options?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Techniqual_Ananlysis
                      </TableCell>
                      {rows.Techniqual_Ananlysis?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          fontFamily: "Overpass",
                          color: "#808080",
                        }}
                      >
                        Ideas
                      </TableCell>
                      {rows.Ideas?.map((row) => (
                        <TableCell>
                          <LinkButton link={row?.url} value={row.title} />
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
